import React from 'react';
import { Box } from '@mui/material';
import SidebarMenu from '../SidebarMenu';
import styles from './styles';

type SidebarItem = {
  path: string;
  label: string;
  icon?: React.ReactElement;
};

type SidebarProps = {
  items?: SidebarItem[];
};

const Sidebar = ({ items }: SidebarProps) => (
  <Box sx={styles.root}>{items && <SidebarMenu items={items} />}</Box>
);

export default Sidebar;
